<div style="vertical-align: top; margin: 20px; width: 800px;" valign="top">
  <h2>Rezerwacja miejsca parkingowego</h2>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <label class="label">Najemca*:</label>
      <p-dropdown name="tenantId" [options]="companies" [(ngModel)]="reservation.tenantId" placeholder="Wybierz firmę najemcy"></p-dropdown>
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Start*:</label>
      <p-calendar [(ngModel)]="reservation.dateFrom"
                  radonlyInput="true"
                  dateFormat="yy-mm-dd"
                  showTime="true"
                  hourFormat="24"
                  showButtonBar="true"
                  showIcon="true"
                  [locale]="pl">
      </p-calendar>
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Koniec*:</label>
      <p-calendar [(ngModel)]="reservation.dateUntil"
                  radonlyInput="true"
                  dateFormat="yy-mm-dd"
                  showTime="true"
                  hourFormat="24"
                  showButtonBar="true"
                  showIcon="true"
                  [locale]="pl">
      </p-calendar>
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Parking*:</label>
      <p-dropdown name="carparkId" [options]="carparks" [(ngModel)]="reservation.carparkId" placeholder="Wybierz parking"></p-dropdown>
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Numer rejestracyjny:</label>
      <input type="text" maxlength="20" pInputText [(ngModel)]="reservation.licensePlate" />
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Imię:</label>
      <input type="text" maxlength="120" pInputText [(ngModel)]="reservation.firstName" />
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Nazwisko:</label>
      <input type="text" maxlength="120" pInputText [(ngModel)]="reservation.surname" />
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">E-mail*:</label>
      <input type="text" maxlength="120" pInputText [(ngModel)]="reservation.email" />
    </div>
    <div class="ui-g-12 ui-md-6">
      <label class="label">Sposób opłacenia pobytu gościa*:</label>
      <p-dropdown name="paymentMode" [options]="paymentModes" [(ngModel)]="reservation.paymentMode" placeholder="Wybierz sposób opłacenia"></p-dropdown>
    </div>
    <div class="ui-g-12">
      <span style="float: right;">
        <p-button class="button" *ngIf="!reservation.id" (click)="addReservation()" label="Zarezerwuj"></p-button>
        <p-button class="button" *ngIf="reservation.id && reservation.status != 'CANNOT_CANCEL' && reservation.status != 'CANCELLED_TO_SYNCHRONIZE' && reservation.status != 'CANCELLED'" (click)="cancelReservation()" label="Anuluj rezerwację"></p-button>
        <p-button class="button" (click)="cancel()" label="Zamknij"></p-button>
      </span>
    </div>
  </div>
  </div>
